webpackJsonp([438],{

/***/ 1728:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(2363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/dupicate-style-45.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] dupicate-style-45.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c478579", Component.options)
  } else {
    hotAPI.reload("data-v-7c478579", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2363:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("样式冗余")]), _vm._v(" "), _c('h2', [_vm._v("调试时")]), _vm._v(" "), _c('p', [_vm._v("调试时如果你审查元素样式发现有多个重复样式是正常的，因为不同组件可能引用了同样的less源码，而调试时是直接把不同组件样式用"), _c('code', [_vm._v("<style>")]), _vm._v("标签插入页面。")]), _vm._v(" "), _c('h2', [_vm._v("打包时")]), _vm._v(" "), _c('p', [_vm._v("确保在"), _c('code', [_vm._v("vux-loader")]), _vm._v("里使用"), _c('code', [_vm._v("duplicate-style")]), _vm._v("插件来实现对构建css进行冗余压缩。")]), _vm._v(" "), _c('h2', [_vm._v("异步路由的样式")]), _vm._v(" "), _c('p', [_vm._v("一般情况下，打包后异步路由的样式会使用 js 的方式插入到页面，有时候这并不是我们所要的。可以通过配置 "), _c('code', [_vm._v("ExtractTextPlugin")]), _vm._v(" 插件的 "), _c('code', [_vm._v("allChunks")]), _vm._v(" 实现样式抽离。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" ExtractTextPlugin({\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("filename")]), _vm._v(": utils.assetsPath("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'css/[name].[contenthash].css'")]), _vm._v("),\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("allChunks")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v("\n})\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7c478579", module.exports)
  }
}

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1728);

/***/ }),

/***/ 913:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "样式冗余 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 438.0a9b34a5.js